export { default } from './InvestmentDetails'
